import ReactAsyncSelect from 'react-select/async'

export const customStyles = ({ isInvalid, color }: any) => {
  return {
    control: (base: any, { isDisabled }: any) => ({
      ...base,
      backgroundColor: isDisabled
        ? 'var(--bg-disabled, #f9fafb)'
        : 'var(--bg-default, #f3f3f3)',
      minWidth: 176,
      minHeight: 0,
      paddingTop: 17,
      paddingBottom: 37,
      paddingLeft: 4,
      paddingRight: 16,
      lineHeight: 1.2,
      fontSize: 16,
      height: 10,
      maxHeight: 10,
      borderRadius: 16,
      border: '1px solid transparent',
      ':focus-within': {
        border: isInvalid
          ? '1px solid rgb(220, 38, 37, 0.5)'
          : '1px solid #777',
      },
      color,
      boxShadow: '0px 1px 2px 0px #1018280D',
    }),
    multiValue: (state: any, { data }: { data: { isFixed?: boolean } }) => ({
      ...state,
      margin: 0,
      border: '1px solid #D0D5DD',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      padding: `0px ${data?.isFixed ? '5px' : '0px'} 0px 0px`,
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      lineHeight: '20px',
      fontSize: '14px',
      padding: '2px 0px',
      paddingLeft: '9px',
      color: '#303940',
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      borderRadius: '4px',
      color: '#9AA6AC',
      fontSize: '16px',
      cursor: 'pointer',
    }),
    input: (base: any) => ({
      ...base,
      color: color,
      margin: '0px',
      padding: '0px',
      lineHeight: 1.2,
      fontSize: 16,
    }),
    singleValue: (base: any, { isDisabled }: any) => ({
      ...base,
      color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : color,
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: '7px 12px',
      fontSize: '16px',
      lineHeight: 1.2,
      gap: '4px',
    }),
    indicatorSeparator: (base: any) => ({
      display: 'none',
    }),
    placeholder: (base: any) => ({
      display: 'none',
    }),
    clearIndicator: (base: any) => ({
      ...base,
      padding: '6px 8px',
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 1350,
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 10,
      position: 'absolute',
      backgroundColor: 'var(--bg-card)',
      borderRadius: '16px',
      overflow: 'hidden',
      paddingInline: '12px',
      paddingBlock: '8px',
    }),
    option: (base: any, { data, isDisabled, isSelected, isFocused }: any) => ({
      ...base,
      fontWeight: 500,
      color: data.value === 'open_map' ? '#ED3237' : isDisabled
        ? '#3039408F'
        : isSelected
          ? '#fff'
          : 'var(--text-default)',
      paddingLeft: isDisabled ? '6px' : '24px',
      borderBottom: '1px solid #E5E9EB',
      display: (data.value === 'open_map' || isDisabled) ? 'flex' : 'block',
      alignItems: (data.value === 'open_map' || isDisabled) ? 'center' : undefined,
      justifyContent: (data.value === 'open_map') ? 'center' : undefined,
      gap: isDisabled ? '4px' : undefined,
      wordBreak: 'break-all',
      borderRadius: '12px',

      backgroundColor: data.value === 'open_map' ? '#ED323712' : isSelected
        ? '#ED3237'
        : isFocused
          ? '#F9F8F7'
          : 'transparent',

      // smooth hover transition (optional)
      transition: 'background-color 0.15s ease, color 0.15s ease',
    }),
  }
}

export default function AsyncSelect({ isInvalid, ...props }: any) {
  return (
    <ReactAsyncSelect
      styles={customStyles({
        isInvalid,
        color: '#000',
      })}
      {...props}
    />
  )
}
